<template>
  <div class="app-evn-settings-wrapper">
    <slot name="txtBefore"></slot>
    <Change>
      <template v-for="slot in possibleChildSlotsFor('Change')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Change>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import Change from './Change.vue'
import { mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'EvnWrapper',
  mixins: [
    transaction('changeEvnSettings'),
    slotProxy()
  ],
  components: { Change },
  created: function () {
    this.goToViewState()
  },
  methods: {
    ...mapMutations('evnSettings', [
      'goToViewState'
    ])
  }
}
</script>
